import React, {
  useCallback,
} from 'react';
import PropTypes from 'prop-types';

import {
  Pane,
  Row,
  Col,
  AccordionStatus,
  AccordionSet,
  ExpandAllButton,
} from '@folio/stripes/components';
import { withStripes } from '@folio/stripes/core';

import {
  ActionItem,
  NavigateBackPaneFirstMenu,
  LastMenuButton,
} from '../../../../components/common';
import {
  GeneralInformation,
  AssignedUsers,
} from './components';

import {
  SETTINGS_DETAIL_VIEW_PANE_WIDTH,
  ICONS, TEAM_FIELDS,
} from '../../../../constants';

const TeamView = ({
  team,
  users,
  onBack,
  onEdit,
  onDelete,
  stripes,
}) => {
  const hasEditCreatePermission = stripes.hasPerm('ui-task-list.teams.create-edit');
  const hasEditDeletePermission = stripes.hasPerm('ui-task-list.teams.delete');

  const initialAccordionState = {
    general: true,
    metadata: false,
    assignedUsers: true,
  };

  const getFirstMenu = useCallback(() => (
    <NavigateBackPaneFirstMenu onClickHandler={onBack} />
  ), [onBack]);

  const getLastMenu = () => {
    if (hasEditCreatePermission && !hasEditDeletePermission) {
      return (
        <LastMenuButton
          id="editTeamAction"
          labelId="action.edit"
          onClick={onEdit}
        />
      );
    }

    return null;
  };

  // eslint-disable-next-line react/prop-types
  const getActionMenu = ({ onToggle }) => {
    if (hasEditDeletePermission) {
      return (
        <>
          <ActionItem
            icon={ICONS.EDIT}
            id="editTeamAction"
            messageId="action.edit"
            onClickHandler={onEdit}
            onToggle={onToggle}
          />
          <ActionItem
            icon={ICONS.DELETE}
            id="deleteTeamAction"
            messageId="action.delete"
            onClickHandler={onDelete}
            onToggle={onToggle}
          />
        </>
      );
    }

    return null;
  };

  return (
    <Pane
      data-test-team-details-view
      actionMenu={getActionMenu}
      defaultWidth={SETTINGS_DETAIL_VIEW_PANE_WIDTH}
      firstMenu={getFirstMenu()}
      lastMenu={getLastMenu()}
      paneTitle={team[TEAM_FIELDS.NAME]}
    >
      <AccordionStatus>
        <Row end="xs">
          <Col xs>
            <ExpandAllButton />
          </Col>
        </Row>
        <AccordionSet initialStatus={initialAccordionState}>
          <GeneralInformation team={team} />
          <AssignedUsers users={users} />
        </AccordionSet>
      </AccordionStatus>
    </Pane>
  );
};

TeamView.propTypes = {
  stripes: PropTypes.shape({
    hasPerm: PropTypes.func.isRequired,
  }).isRequired,
  team: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  onBack: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default withStripes(TeamView);
